import { tokens } from "../../../theme";
import { Box, Typography, useTheme } from "@mui/material";
import ActionButton from "./ActionButton";
import ActionMenu from "./ActionMenu";
import { releaseStyles } from "../styles";
import {
  actionText,
  formatLabelDate,
  isDestructiveAction,
  labelStatusText,
  pickForwardLabelAction,
} from "../summaryHelpers";
import { getHeaders } from "../../../utils/apiclient";

// One highlighted label: version, status, date and at most one forward action.
const ActiveLabelRow = ({
  release,
  releaseLabel,
  app,
  showReleaseStatusDialog,
}) => {
  const theme = useTheme();
  const { labelsDrawer, statusColors } = releaseStyles(tokens(theme.paletteId));

  const { bg, fg, border } = statusColors(releaseLabel?.status);
  const actions = releaseLabel?.actionsAllowed || [];
  const forwardAction = pickForwardLabelAction(actions);
  const path = `/apps/${app}/releases/${release?.name}/release-labels/${releaseLabel?.name}`;

  const runAction = (action) =>
    showReleaseStatusDialog(
      `Perform action ${action} on release-label ${releaseLabel?.name}`,
      `/${release?.name}/release-labels/${releaseLabel?.name}`,
      { headers: { ...getHeaders(), Action: action } }
    );

  const menuItems = actions
    .filter((action) => action !== forwardAction)
    .map((action) => ({
      key: action,
      action,
      path,
      text: actionText(action, releaseLabel?.status),
      destructive: isDestructiveAction(action),
      onClick: () => runAction(action),
    }));

  return (
    <Box sx={labelsDrawer.activeRow(bg, border)}>
      <Typography sx={labelsDrawer.version}>{releaseLabel?.name}</Typography>
      <Box sx={labelsDrawer.statusCell}>
        <Typography component="span" sx={labelsDrawer.statusText(fg)}>
          {labelStatusText(releaseLabel?.status)}
        </Typography>
        <Typography component="span" sx={labelsDrawer.date}>
          {formatLabelDate(releaseLabel?.dateCreated)}
        </Typography>
      </Box>
      <Box sx={labelsDrawer.rowActions}>
        {forwardAction ? (
          <ActionButton
            action={forwardAction}
            path={path}
            text={actionText(forwardAction, releaseLabel?.status)}
            variant="contained"
            sx={labelsDrawer.rowButton}
            onClick={() => runAction(forwardAction)}
          />
        ) : null}
        <ActionMenu items={menuItems} />
      </Box>
    </Box>
  );
};

export default ActiveLabelRow;
